var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13340_9483",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13340_9483)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.9501 11.25C4.5501 10.8278 5.19176 10.5139 5.8751 10.3083C6.55843 10.1028 7.26676 9.99998 8.0001 9.99998C8.73343 9.99998 9.44176 10.1028 10.1251 10.3083C10.8084 10.5139 11.4501 10.8278 12.0501 11.25C12.439 10.7944 12.7279 10.2889 12.9168 9.73331C13.1057 9.17775 13.2001 8.59998 13.2001 7.99998C13.2001 6.5592 12.6933 5.33231 11.6796 4.31931C10.6659 3.30642 9.43815 2.79998 7.99626 2.79998C6.55438 2.79998 5.32788 3.30642 4.31676 4.31931C3.30565 5.33231 2.8001 6.5592 2.8001 7.99998C2.8001 8.59998 2.89454 9.17775 3.08343 9.73331C3.27232 10.2889 3.56121 10.7944 3.9501 11.25ZM8.0001 9.19998C7.33343 9.19998 6.76676 8.96664 6.3001 8.49998C5.83343 8.03331 5.6001 7.46664 5.6001 6.79998C5.6001 6.13331 5.83343 5.56664 6.3001 5.09998C6.76676 4.63331 7.33343 4.39998 8.0001 4.39998C8.66676 4.39998 9.23343 4.63331 9.7001 5.09998C10.1668 5.56664 10.4001 6.13331 10.4001 6.79998C10.4001 7.46664 10.1668 8.03331 9.7001 8.49998C9.23343 8.96664 8.66676 9.19998 8.0001 9.19998ZM8.00476 14.4C7.12388 14.4 6.29454 14.2333 5.51676 13.9C4.73899 13.5666 4.05843 13.1083 3.4751 12.525C2.89176 11.9416 2.43343 11.2613 2.1001 10.484C1.76676 9.70664 1.6001 8.87609 1.6001 7.99231C1.6001 7.10853 1.76676 6.28053 2.1001 5.50831C2.43343 4.73609 2.89176 4.05831 3.4751 3.47498C4.05843 2.89164 4.73876 2.43331 5.5161 2.09998C6.29343 1.76664 7.12399 1.59998 8.00776 1.59998C8.89154 1.59998 9.71954 1.76664 10.4918 2.09998C11.264 2.43331 11.9418 2.89164 12.5251 3.47498C13.1084 4.05831 13.5668 4.73731 13.9001 5.51198C14.2334 6.28675 14.4001 7.11453 14.4001 7.99531C14.4001 8.8762 14.2334 9.70553 13.9001 10.4833C13.5668 11.2611 13.1084 11.9416 12.5251 12.525C11.9418 13.1083 11.2628 13.5666 10.4881 13.9C9.71332 14.2333 8.88554 14.4 8.00476 14.4Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.fe8dcdfff46681fd7f836b8fded952d4.svg";
export { ForwardRef as ReactComponent };